// import Home from './views/Home.vue';
import store from './store';
import theLocalStorage from './utils/localStorage';

const authGuard = (to, from, next) => {
    if (to.name === 'login') next();

    const state = theLocalStorage.get();

    if (!!state && !!state.user && !!state.user.id) {
        store.commit('state', state);
        next();
    }

    if (store.getters.user) next();
    else next('/');
}

export default [{
        path: '/',
        name: 'login',
        component: () => import('./views/Login.vue'),
        exact: true
    },
    {
        path: '/app',
        component: () => import('./App.vue'),
        children: [{
                path: '/',
                name: 'home',
                component: () => import('./views/Home.vue'),
            },
            {
                path: '/about',
                name: 'about',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import('./views/About.vue'),
            },
            {
                path: '/venues',
                name: 'venues',
                component: () => import('./views/Venues.vue'),
            },
            {
                path: '/rounds',
                name: 'rounds',
                component: () => import('./views/Rounds.vue'),
            },
            {
                path: '/round-in-progress',
                name: 'roundInProgress',
                component: () => import('./views/RoundInProgress.vue'),
            },
            {
                path: '/checkpoint-form',
                name: 'checkpointForm',
                component: () => import('./views/CheckpointForm.vue'),
            },
            {
                path: '/open-rounds',
                name: 'openRounds',
                component: () => import('./views/OpenRounds.vue'),
            },
        ],
        beforeEnter: authGuard,
    },
];
